import { useContext, useState } from "react";
import { CiLight } from "react-icons/ci";
import { FaBars, FaTimes } from "react-icons/fa";
import { MdDarkMode } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { Link, animateScroll, scroller } from "react-scroll";
import { Container, Toggler } from "..";
import jiff from "../../assets/img/Jiffyb.png";
// import logo from "../../assets/svg/logo.svg";
import { navLinks } from "../../constants";
import { Button } from "../Button";
import { ThemeContext } from "../context";
import {
  ButtonContainer,
  Logo,
  MobileContainer,
  MobileIcon,
  MobileMenu,
  MobileMenuItem,
  NavContainer,
  NavContent,
  NavHeader,
  NavLinks,
  NavMenu,
} from "./Nav.elements";

export const Navigation = () => {
  const { rooTheme, scrollNavbar, toggler } = useContext(ThemeContext);
  const [click, setClick] = useState(false);

  const toggleHome = (): void => {
    animateScroll.scrollToTop();
  };
  
  const toggleGetStarted = (): void => {
    scroller.scrollTo("Get Started", {
      duration: 1500,
      smooth: true,
      offset: -100,
    });
  };

  const handleClick = () => setClick(!click);

  return (
    <NavHeader scrollNavbar={scrollNavbar} rooTheme={rooTheme}>
      <Container>
        <NavContainer>
          <NavContent>
            <Logo
              src={rooTheme === "dark" ? jiff : jiff}
              alt="logo"
              onClick={toggleHome}
            />
            <NavMenu>
              {navLinks?.map(({ pathname, title, scrollOffset }, index) => {
                return (
                  <NavLinks key={index} rooTheme={rooTheme}>
                    <Link
                      to={title}
                      spy={true}
                      smooth={true}
                      offset={scrollOffset}
                      duration={1500}
                    >
                      <NavLink to={{ pathname }}>{title}</NavLink>
                    </Link>
                  </NavLinks>
                );
              })}
            </NavMenu>
            <ButtonContainer>
              <Toggler onClick={toggler}>
                {rooTheme === "dark" ? (
                  <CiLight className="text-white" />
                ) : (
                  <MdDarkMode className="text-orange-300" />
                )}
              </Toggler>
              <Button
                children="Get Early Access"
                background="#007FFF"
                color="#fff"
                paddingvals="13.5px 30px"
                ispadding={true}
                type="button"
                onClick={toggleGetStarted}
              />
            </ButtonContainer>

            <MobileIcon onClick={handleClick} rooTheme={rooTheme}>
              {click ? <FaTimes /> : <FaBars />}
            </MobileIcon>
          </NavContent>
        </NavContainer>
      </Container>

      <MobileContainer click={click} rooTheme={rooTheme}>
        <MobileMenu>
          {navLinks?.map(({ pathname, title, scrollOffset }, index) => {
            return (
              <MobileMenuItem key={index} click={click} rooTheme={rooTheme}>
                <Link
                  to={title}
                  spy={true}
                  smooth={true}
                  offset={scrollOffset}
                  duration={1500}
                >
                  <NavLink to={{ pathname }}>{title}</NavLink>
                </Link>
              </MobileMenuItem>
            );
          })}
        </MobileMenu>

        <div>
          <Toggler onClick={toggler}>
            {rooTheme === "dark" ? (
              <CiLight className="text-white" />
            ) : (
              <MdDarkMode className="text-orange-300" />
            )}
          </Toggler>
        </div>

        <Button
          children="Get Early Access"
          background="#007FFF"
          color="#fff"
          paddingvals="13px 30px"
          ispadding={true}
          type="button"
          onClick={toggleGetStarted}
        />
      </MobileContainer>
    </NavHeader>
  );
};
